import React, { useState } from "react";
import { MonitorCheck } from "lucide-react";
import { Button } from "@themes/pollinator/ui/Button";
import { ButtonGroup } from "@themes/pollinator/ui/ButtonGroup";
import { Type } from "@themes/pollinator/ui/Type";
import { useDialog } from "@platform/store";

const VideoUIPermissionsTip: React.FC = () => {
  const { openDialog } = useDialog();
  const [isRequesting, setIsRequesting] = useState(false);

  const handleAllowAccess = async () => {
    setIsRequesting(true);

    try {
      // Try to request permissions
      const stream = await navigator.mediaDevices.getUserMedia({
        video: true,
        audio: true,
      });

      // If successful, stop the stream immediately
      stream.getTracks().forEach((track) => track.stop());

      // Refresh the page to retry device detection
      window.location.reload();
    } catch (error) {
      // Open the instructions dialog
      openDialog("permissionsGuide");
    } finally {
      setIsRequesting(false);
    }
  };

  return (
    <Button
      onClick={handleAllowAccess}
      disabled={isRequesting}
      variant="link-inline"
      className="underline px-0 inline-block text-error-700 hover:text-error-800"
      typeVariant="h6"
    >
      Allow Device Access
    </Button>
  );
};

export default VideoUIPermissionsTip;
